import { ref } from 'vue';
import type { UnleashClient } from 'unleash-proxy-client';

let client: UnleashClient | null = null;

// Bumped on every client change, so flags can re-read without each one subscribing to the client.
export const flagsRevision = ref(0);

export function setUnleashClient(c: UnleashClient): void {
  client = c;
  ['initialized', 'ready', 'update'].forEach((event) =>
    c.on(event, () => {
      flagsRevision.value++;
    })
  );
  flagsRevision.value++;
}

export function isFeatureEnabled(flag: string): boolean {
  return client?.isEnabled(flag) ?? false;
}

export function waitForFlagsReady(timeoutMs = 5000): Promise<void> {
  if (!client || client.isReady()) return Promise.resolve();

  const c = client;
  return new Promise((resolve) => {
    const timer = setTimeout(resolve, timeoutMs);
    c.once('ready', () => {
      clearTimeout(timer);
      resolve();
    });
  });
}

export function isMaintenanceModeEnabled(): boolean {
  if (isFeatureEnabled('maintenance-mode-bypass')) return false;
  return (
    Boolean(import.meta.env.VITE_MAINTENANCE_MODE) ||
    isFeatureEnabled('maintenance-mode')
  );
}
